import { RefObject } from "react";
import { scroller } from "react-scroll";
import useUpdateEffect from "./useUpdateEffect";

const usePaginationScroll = (
  resultsRef: RefObject<HTMLElement>,
  deps: any[],
  scrollTarget = "listing-page-scroll",
) => {
  useUpdateEffect(() => {
    scroller.scrollTo(scrollTarget, { duration: 200, smooth: true, offset: -100 });
    setTimeout(() => resultsRef.current?.focus({ preventScroll: true }), 250);
  }, deps);
};

export default usePaginationScroll;
